/** Spanish for the billing area. Keys are the exact English strings the UI renders. */
const billing = {
  // Invoice PDF downloads
  'Download PDF': 'Descargar PDF',
  'Download {n} PDF': 'Descargar {n} PDF',
  'Download {n} PDFs': 'Descargar {n} PDF',
  'Download the selected invoices together as one PDF.':
    'Descargar las facturas seleccionadas juntas en un solo PDF.',
  'Select fewer invoices and try again.': 'Seleccione menos facturas e inténtelo de nuevo.',
  'One or more invoice PDFs are unavailable. Refresh the invoices and try again.':
    'Uno o más PDF de facturas no están disponibles. Actualice las facturas e inténtelo de nuevo.',
  'Could not download invoice PDFs. Please try again.':
    'No se pudieron descargar los PDF de las facturas. Inténtelo de nuevo.',
  'Download invoice {number} PDF': 'Descargar PDF de la factura {number}',
  'PDF unavailable': 'PDF no disponible',
  'PDF available after this invoice is created in QuickBooks.':
    'El PDF estará disponible cuando se cree esta factura en QuickBooks.',
  'Preparing PDF...': 'Preparando PDF...',
  'This invoice PDF is too large to download. Contact MedEffects for help.':
    'El PDF de esta factura es demasiado grande para descargarlo. Comuníquese con MedEffects para obtener ayuda.',
  'This invoice PDF is unavailable. Refresh the invoices and try again.':
    'El PDF de esta factura no está disponible. Actualice las facturas e inténtelo de nuevo.',
  'Could not download the invoice PDF. Please try again.':
    'No se pudo descargar el PDF de la factura. Inténtelo de nuevo.',
  // ---- Invoices page: header, subtitles, toolbar --------------------------------------------
  Invoices: 'Facturas',
  'Invoices and payments for your practice.': 'Facturas y pagos de su consultorio.',
  'Invoices are available to the practice owner and to MedEffects staff. Ask your practice owner to pay or review invoices.':
    'Las facturas están disponibles para el propietario del consultorio y para el personal de MedEffects. Pida al propietario de su consultorio que pague o revise las facturas.',
  'Every QuickBooks invoice for every clinic, history included.':
    'Todas las facturas de QuickBooks de todas las clínicas, historial incluido.',
  'Every QuickBooks invoice for your clinic, history included.':
    'Todas las facturas de QuickBooks de su clínica, historial incluido.',
  'Every QuickBooks invoice for your clinics, history included.':
    'Todas las facturas de QuickBooks de sus clínicas, historial incluido.',
  'Search invoices...': 'Buscar facturas...',
  'Pull the latest invoices and balances from QuickBooks now':
    'Obtener ahora las últimas facturas y saldos de QuickBooks',
  'Syncing...': 'Sincronizando...',
  'Sync from QuickBooks': 'Sincronizar desde QuickBooks',
  'Online payments are not available right now':
    'Los pagos en línea no están disponibles en este momento',
  'Tick the open invoices to pay first': 'Marque primero las facturas abiertas que desea pagar',
  'Pay {n} invoice for {clinic}': 'Pagar {n} factura de {clinic}',
  'Pay {n} invoices for {clinic}': 'Pagar {n} facturas de {clinic}',
  'Pay selected · {amount}': 'Pagar seleccionadas · {amount}',
  'Pay selected': 'Pagar seleccionadas',
  'TEST MODE - payments go to the QuickBooks sandbox, not a real merchant account.':
    'MODO DE PRUEBA: los pagos van al entorno de pruebas de QuickBooks, no a una cuenta de comerciante real.',
  'Invoices can still be viewed.': 'Las facturas se pueden seguir consultando.',
  'QuickBooks could not be reached. Please try again shortly.':
    'No se pudo conectar con QuickBooks. Inténtelo de nuevo en unos momentos.',

  // Paid banner
  '{amount} paid for {clinic}': '{amount} pagado a nombre de {clinic}',
  'the clinic': 'la clínica',
  'invoice {list}': 'factura {list}',
  'invoices {list}': 'facturas {list}',
  'Bank payments settle in a few business days.':
    'Los pagos bancarios se liquidan en unos días hábiles.',
  'The payment went through; QuickBooks will show it once our team finishes the record.':
    'El pago se realizó; QuickBooks lo mostrará cuando nuestro equipo termine de registrarlo.',
  Dismiss: 'Descartar',

  // Statement summary
  'Statement summary': 'Resumen del estado de cuenta',
  Outstanding: 'Pendiente de pago',
  'across {count} unpaid invoice · {scope}': 'en {count} factura sin pagar · {scope}',
  'across {count} unpaid invoices · {scope}': 'en {count} facturas sin pagar · {scope}',
  'this clinic': 'esta clínica',
  'your clinic': 'su clínica',
  'all clinics': 'todas las clínicas',
  'your clinics': 'sus clínicas',
  Overdue: 'Vencida',
  '{count} invoice past due': '{count} factura vencida',
  '{count} invoices past due': '{count} facturas vencidas',
  Ledger: 'Libro mayor',
  invoice: 'factura',
  invoices: 'facturas',
  '{year} – today': '{year} – hoy',
  'no invoices yet': 'aún no hay facturas',
  'The last sync from QuickBooks failed': 'La última sincronización desde QuickBooks falló',
  'Balances are as of this sync': 'Los saldos corresponden a esta sincronización',
  'not synced yet': 'aún no sincronizado',
  'synced {ago}': 'sincronizado {ago}',
  'sync failed · last good {ago}': 'sincronización fallida · última correcta {ago}',
  'just now': 'hace un momento',
  '{n} min ago': 'hace {n} min',
  '{n} hour ago': 'hace {n} hora',
  '{n} hours ago': 'hace {n} horas',

  // Views and filters
  'Invoice views': 'Vistas de facturas',
  All: 'Todos',
  Unpaid: 'Sin pagar',
  'Partially paid': 'Pagada parcialmente',
  Paid: 'Pagada',
  'Needs attention': 'Requiere atención',
  Clinic: 'Clínica',
  'All clinics': 'Todas las clínicas',

  // Selection bar
  '{n} selected · {amount}': '{n} seleccionadas · {amount}',
  'for {clinic}': 'de {clinic}',
  'Open invoices for {clinic} can be paid together.':
    'Las facturas abiertas de {clinic} se pueden pagar juntas.',
  'Tick every open invoice on this page for this clinic':
    'Marcar todas las facturas abiertas de esta clínica en esta página',
  'Select all {n}': 'Seleccionar las {n}',
  'Select all open invoices': 'Seleccionar todas las facturas abiertas',
  'Select all open invoices for {clinic}': 'Seleccionar todas las facturas abiertas de {clinic}',
  Clear: 'Limpiar',

  // Table
  'INVOICE #': 'N.º DE FACTURA',
  CLINIC: 'CLÍNICA',
  DATE: 'FECHA',
  DUE: 'VENCIMIENTO',
  AMOUNT: 'IMPORTE',
  BALANCE: 'SALDO',
  STATUS: 'ESTADO',
  ACTIONS: 'ACCIONES',
  METHOD: 'MÉTODO',
  INVOICES: 'FACTURAS',
  'The number QuickBooks assigned, with the MedEffects order ID beneath it when the app created the invoice.':
    'El número asignado por QuickBooks, con el ID del pedido de MedEffects debajo cuando la aplicación creó la factura.',
  'What is still owed on this invoice, as of the last QuickBooks sync.':
    'Lo que aún se debe de esta factura, según la última sincronización con QuickBooks.',
  'Click to sort': 'Haga clic para ordenar',
  ascending: 'ascendente',
  descending: 'descendente',
  'Sort by {column}': 'Ordenar por {column}',
  'No invoices found': 'No se encontraron facturas',
  'Pay invoice {number}': 'Pagar la factura {number}',
  'Include in the payment': 'Incluir en el pago',
  'Finish paying {clinic} first - one clinic per payment':
    'Termine primero el pago de {clinic}: una clínica por pago',
  'View in QuickBooks': 'Ver en QuickBooks',
  item: 'artículo',
  '{count} item': '{count} artículo',
  '{count} items': '{count} artículos',
  '{units} units': '{units} unidades',
  '{price}/unit': '{price}/unidad',
  Open: 'Abierta',
  Voided: 'Anulada',
  Pending: 'Pendiente',
  Processing: 'En proceso',
  Failed: 'Con error',
  'Needs Attention': 'Requiere atención',
  'Retrying...': 'Reintentando...',
  Retry: 'Reintentar',

  // Pager
  'No invoices': 'Sin facturas',
  'Showing {from}–{to} of {total} invoice': 'Mostrando {from}–{to} de {total} factura',
  'Showing {from}–{to} of {total} invoices': 'Mostrando {from}–{to} de {total} facturas',
  '{amount} outstanding in this view': '{amount} pendiente de pago en esta vista',
  Previous: 'Anterior',
  'Page {page} of {total}': 'Página {page} de {total}',
  Next: 'Siguiente',

  // Payments taken in the app
  'Paid through MedEffects': 'Pagado a través de MedEffects',
  'Bank account (ACH) payments taken in the app · debits are re-checked until they settle':
    'Pagos con cuenta bancaria (ACH) realizados en la aplicación · los débitos se vuelven a verificar hasta que se liquidan',
  'No payments yet': 'Aún no hay pagos',
  'Bank account': 'Cuenta bancaria',
  'ending {last4}': 'terminada en {last4}',
  'Confirming with Intuit': 'Confirmando con Intuit',
  'Paid - not in QuickBooks yet': 'Pagado - aún no está en QuickBooks',
  Declined: 'Rechazado',
  Returned: 'Devuelto',
  review: 'revisar',
  'Record in QB': 'Registrar en QB',
  'Check status': 'Consultar estado',
  'Ask Intuit how this transaction stands now':
    'Consultar a Intuit el estado actual de esta transacción',

  // Invoices page: client-side error fallbacks and the server sentences its calls can return
  'Could not load invoices.': 'No se pudieron cargar las facturas.',
  'Could not load payments.': 'No se pudieron cargar los pagos.',
  'Sync from QuickBooks failed.': 'La sincronización desde QuickBooks falló.',
  'Retry failed.': 'El reintento falló.',
  'That did not work.': 'Eso no funcionó.',
  'Cannot sync invoices: no QuickBooks company is connected. Connect QuickBooks on the Integrations tab first.':
    'No se pueden sincronizar las facturas: no hay ninguna empresa de QuickBooks conectada. Conecte QuickBooks primero en la pestaña Integraciones.',
  'Invoice not found': 'Factura no encontrada',
  'Order for invoice not found': 'No se encontró el pedido de la factura',
  'Payment not found': 'Pago no encontrado',
  'This payment has no Intuit transaction to check.':
    'Este pago no tiene ninguna transacción de Intuit que consultar.',

  // ---- Pay invoices dialog ------------------------------------------------------------------
  'Pay invoices': 'Pagar facturas',
  'Payment received': 'Pago recibido',
  'Pay {amount}': 'Pagar {amount}',
  '{n} invoice': '{n} factura',
  '{n} invoices': '{n} facturas',
  'TEST MODE (sandbox)': 'MODO DE PRUEBA (sandbox)',
  Close: 'Cerrar',
  '{amount} paid': '{amount} pagado',
  'ref {id}': 'ref. {id}',
  'Invoice {number}': 'Factura {number}',
  'Bank payments settle in a few business days. The invoices show as paid now.':
    'Los pagos bancarios se liquidan en unos días hábiles. Las facturas ya aparecen como pagadas.',
  'Your payment went through. QuickBooks will show it shortly - our team has been notified to finish the record.':
    'Su pago se realizó. QuickBooks lo mostrará en breve; nuestro equipo ha sido notificado para terminar el registro.',
  Done: 'Listo',
  'due {date}': 'vence {date}',
  'Pay by bank account (ACH)': 'Pagar con cuenta bancaria (ACH)',
  'Name on account': 'Nombre en la cuenta',
  'Routing number': 'Número de ruta',
  'Account type': 'Tipo de cuenta',
  'Personal checking': 'Cuenta de cheques personal',
  'Personal savings': 'Cuenta de ahorros personal',
  'Business checking': 'Cuenta de cheques empresarial',
  'Business savings': 'Cuenta de ahorros empresarial',
  'Account number': 'Número de cuenta',
  'Confirm account number': 'Confirmar número de cuenta',
  Phone: 'Teléfono',
  'Authorize the debit': 'Autorizar el débito',
  'I authorize MedEffects to debit this account for {amount} today. Bank payments settle in a few business days; a debit the bank returns leaves the invoices unpaid.':
    'Autorizo a MedEffects a debitar {amount} de esta cuenta hoy. Los pagos bancarios se liquidan en unos días hábiles; un débito devuelto por el banco deja las facturas sin pagar.',
  'Details go straight to Intuit (QuickBooks Payments). MedEffects never stores account numbers.':
    'Los datos van directamente a Intuit (QuickBooks Payments). MedEffects nunca guarda números de cuenta.',
  'Processing...': 'Procesando...',

  // Dialog: validation
  'Enter the name on the account.': 'Ingrese el nombre que figura en la cuenta.',
  'The routing number is 9 digits.': 'El número de ruta tiene 9 dígitos.',
  'Enter the account number.': 'Ingrese el número de cuenta.',
  'The account numbers do not match.': 'Los números de cuenta no coinciden.',
  'Pick the account type.': 'Seleccione el tipo de cuenta.',
  'Enter a phone number - the bank requires one for a debit.':
    'Ingrese un número de teléfono: el banco lo exige para un débito.',
  'Enter a 10-digit phone number, with an optional US country code 1 and no extension.':
    'Ingrese un número de teléfono de 10 dígitos, con el código de país de EE. UU. 1 opcional y sin extensión.',
  'Tick the box to authorize the debit.': 'Marque la casilla para autorizar el débito.',

  // Dialog: Intuit tokenization
  'Online payments are not available right now (payment endpoint is not Intuit).':
    'Los pagos en línea no están disponibles en este momento (el punto de conexión de pagos no es Intuit).',
  'Intuit could not be reached to check those details. Nothing was charged. Please try again.':
    'No se pudo conectar con Intuit para verificar esos datos. No se realizó ningún cargo. Inténtelo de nuevo.',
  'Intuit could not accept those details. Please check the routing and account numbers.':
    'Intuit no pudo aceptar esos datos. Verifique el número de ruta y el número de cuenta.',
  'The bank account details could not be verified.':
    'No se pudieron verificar los datos de la cuenta bancaria.',
  'The bank account was declined.': 'La cuenta bancaria fue rechazada.',
  'Intuit could not process the details right now. Please try again in a few minutes.':
    'Intuit no pudo procesar los datos en este momento. Inténtelo de nuevo en unos minutos.',
  'Intuit could not accept those details. Please check them and try again.':
    'Intuit no pudo aceptar esos datos. Verifíquelos e inténtelo de nuevo.',

  // Dialog: outcomes
  'We did not get an answer about this payment. Do NOT try again - check the Paid view in a minute, or contact MedEffects.':
    'No recibimos respuesta sobre este pago. NO lo intente de nuevo: consulte la vista Pagada en un minuto o comuníquese con MedEffects.',
  'The amount owed changed. Nothing was charged.':
    'El importe adeudado cambió. No se realizó ningún cargo.',
  'Close this window and review the refreshed list.':
    'Cierre esta ventana y revise la lista actualizada.',
  'Too many payment attempts in a short time. Please wait a minute and try again.':
    'Demasiados intentos de pago en poco tiempo. Espere un minuto e inténtelo de nuevo.',
  'The payment could not be processed.': 'No se pudo procesar el pago.',

  // Dialog: the server's own sentences for POST /invoices/pay (invoice-payments.service)
  'Online payments are switched off right now. Please try again later.':
    'Los pagos en línea están desactivados en este momento. Inténtelo de nuevo más tarde.',
  'Sign in to pay an invoice.': 'Inicie sesión para pagar una factura.',
  'Only bank account (ACH) payments are accepted. Card payments are not available.':
    'Solo se aceptan pagos con cuenta bancaria (ACH). Los pagos con tarjeta no están disponibles.',
  'Only bank account (ACH) payments are accepted. Nothing was charged.':
    'Solo se aceptan pagos con cuenta bancaria (ACH). No se realizó ningún cargo.',
  'Too many refused payment attempts. Please wait an hour or contact MedEffects.':
    'Demasiados intentos de pago rechazados. Espere una hora o comuníquese con MedEffects.',
  'Pick invoices from one clinic at a time - each clinic is paid separately.':
    'Seleccione facturas de una sola clínica a la vez: cada clínica se paga por separado.',
  'These invoices belong to different QuickBooks customers.':
    'Estas facturas pertenecen a distintos clientes de QuickBooks.',
  'These invoices belong to a QuickBooks company that is no longer connected.':
    'Estas facturas pertenecen a una empresa de QuickBooks que ya no está conectada.',
  'A payment for one of these invoices is already in progress or awaiting review. Check the Paid view on the Invoices tab before trying again.':
    'Ya hay un pago en curso o en revisión para una de estas facturas. Consulte la vista Pagada en la pestaña Facturas antes de intentarlo de nuevo.',
  'A payment for one of these invoices is already in progress. Check the Paid view on the Invoices tab before trying again.':
    'Ya hay un pago en curso para una de estas facturas. Consulte la vista Pagada en la pestaña Facturas antes de intentarlo de nuevo.',
  'QuickBooks could not be reached to confirm the balance. Nothing was charged. Please try again in a few minutes.':
    'No se pudo conectar con QuickBooks para confirmar el saldo. No se realizó ningún cargo. Inténtelo de nuevo en unos minutos.',
  'One of the invoices could not be found.': 'No se encontró una de las facturas.',
  'Nothing is owed on the selected invoices.': 'No se debe nada de las facturas seleccionadas.',
  'This payment cannot be resumed: its one-time token is gone.':
    'Este pago no se puede reanudar: su token de un solo uso ya no existe.',
  'We could not confirm the payment with the processor. Do NOT try again - our team has been alerted and will confirm whether it went through.':
    'No pudimos confirmar el pago con el procesador. NO lo intente de nuevo: nuestro equipo ya fue alertado y confirmará si se realizó.',

  // ---- Dashboard ----------------------------------------------------------------------------
  Dashboard: 'Panel',
  "Welcome back! Here's what's happening today.":
    '¡Le damos la bienvenida de nuevo! Esto es lo que está pasando hoy.',
  'New IVR': 'Nuevo IVR',
  'New Order': 'Nuevo pedido',
  "Today's Orders": 'Pedidos de hoy',
  'Pending Orders': 'Pedidos pendientes',
  'Shipped Today': 'Enviados hoy',
  'Active Sales Reps': 'Representantes de ventas activos',
  'Total Orders (MTD)': 'Total de pedidos (mes en curso)',
  'Approval Rate': 'Tasa de aprobación',
  'Recent Orders': 'Pedidos recientes',
  'View All': 'Ver todos',
  'No recent orders': 'No hay pedidos recientes',
  'N/A': 'N/A',
  'Pending Actions': 'Acciones pendientes',
  '{n} Orders Pending': '{n} pedidos pendientes',
  'Awaiting approval': 'En espera de aprobación',
  Review: 'Revisar',
  '{n} IVR Pending': '{n} IVR pendientes',
  'Awaiting verification': 'En espera de verificación',
  Verify: 'Verificar',
  '{n} Orders Shipped': '{n} pedidos enviados',
  'In transit': 'En tránsito',
  Track: 'Rastrear',
  'Recent IVR': 'IVR recientes',
  'No recent IVR requests': 'No hay solicitudes de IVR recientes',

  // ---- Reports ------------------------------------------------------------------------------
  'Reports & Analytics': 'Informes y análisis',
  'Download comprehensive reports.': 'Descargue informes completos.',
  'Daily Order Tracker (Excel)': 'Seguimiento diario de pedidos (Excel)',
  'All Orders Report': 'Informe de todos los pedidos',
  'IVR Reports': 'Informes de IVR',
  'Exporting...': 'Exportando...',
  Export: 'Exportar',
  'Failed to export report': 'No se pudo exportar el informe',
};

export default billing;
